import {FC, useCallback} from 'react';
import styled from 'styled-components';

import {HoobiizWhiteLabeling} from '@shared/dynamo_model';

import {Input} from '@shared-frontend/components/core/input_v2';

import {adminInputTheme} from '@src/components/core/theme';

interface AdminUserAndGroupThemeLoginConfigProps {
  data?: HoobiizWhiteLabeling['login'];
  onChange: (data?: HoobiizWhiteLabeling['login']) => void;
}

export const AdminUserAndGroupThemeLoginConfig: FC<AdminUserAndGroupThemeLoginConfigProps> = ({
  data,
  onChange,
}) => {
  const handleTitleChange = useCallback(
    (title?: string) => onChange({...data, title}),
    [onChange, data]
  );

  return (
    <Wrapper>
      <div>
        <Input
          label="Titre"
          value={data?.title}
          syncState={handleTitleChange}
          overrides={adminInputTheme}
        />
      </div>
    </Wrapper>
  );
};

AdminUserAndGroupThemeLoginConfig.displayName = 'AdminUserAndGroupThemeLoginConfig';

const Wrapper = styled.div`
  display: flex;
`;
